import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function NuevaAgenda() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [nombre, setNombre] = useState('');
    
    // 🆕 Estados para permisos de usuarios
    const [usuarios, setUsuarios] = useState([]);
    const [permisosUsuarios, setPermisosUsuarios] = useState({});

    let history = useHistory();
    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Obtener información del cliente
        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: '+error);
            });

        // 🆕 Obtener usuarios del cliente para asignar permisos
        axios.get('/usuarios-para-permisos')
            .then(response => {
                if (response.status===200) {
                    setUsuarios(response.data);
                    
                    // Inicializar permisos por defecto para cada usuario
                    const permisosIniciales = {};
                    response.data.forEach(usuario => {
                        permisosIniciales[usuario.id] = {
                            user_id: usuario.id,
                            puede_ver: false,
                            puede_editar: false,
                            puede_crear_citas: false,
                            puede_cancelar_citas: false
                        };
                    });
                    setPermisosUsuarios(permisosIniciales);
                }
            })
            .catch(error => {
                console.log('err: '+error);
            });
    },[]);

    // 🆕 Manejar cambio de permisos
    const handlePermisoChange = (userId, tipoPermiso) => {
        setPermisosUsuarios(prev => ({
            ...prev,
            [userId]: {
                ...prev[userId],
                [tipoPermiso]: !prev[userId][tipoPermiso]
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 Filtrar solo usuarios con al menos un permiso activo
        const permisosActivos = Object.values(permisosUsuarios).filter(permiso => 
            permiso.puede_ver || permiso.puede_editar || permiso.puede_crear_citas || permiso.puede_cancelar_citas
        );

        const conf = {
            client_id: client.client_id,
            nombre: nombre,
            permisos_usuarios: permisosActivos // 🆕 Enviar permisos de usuarios
        };

        axios.post('/crear-agenda', conf)
        .then(response => {
            setLoading(false);
            localStorage.setItem('toastmsg', 'La Agenda "' + nombre + '" Ha Sido Creada');
            history.push('/crear-agendas');
        })
        .catch(err => {
            console.log('ERR: ', err.response?.data || err);
            setLoading(false);
        });
    }

    if (loggedIn) {
        return (

            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-agenda">Parámetros de Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/crear-agendas">Agendas</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Nueva Agenda</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nueva Agenda</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-12">

                                <form id="agenda-form" onSubmit={handleSubmit}>
                                    {/* Card de Información Básica */}
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                <i className="fas fa-calendar-alt"></i> Información de la Agenda
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombre">Nombre de la Agenda o del Servicio</label>
                                                        <input 
                                                            type="text" 
                                                            name="nombre" 
                                                            className="form-control" 
                                                            id="nombre" 
                                                            placeholder="Ej: Agenda Dr. Juan Pérez"
                                                            onChange={(e) => setNombre(e.target.value)}
                                                            required
                                                            disabled={loading}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 🆕 Card de Permisos de Usuarios - SIMPLIFICADO */}
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                <i className="fas fa-users-cog"></i> Permisos de Acceso
                                            </h3>
                                            <p className="card-text text-muted mb-0">
                                            Defina Qué Usuarios Están Autorizados Para Consultar O Gestionar Esta Agenda.
                                            </p>
                                        </div>
                                        <div className="card-body">
                                            {usuarios.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table table-hover table-bordered">
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th style={{width: '70%'}}>Usuario</th>
                                                                <th className="text-center" style={{width: '30%'}}>
                                                                    <i className="fas fa-eye"></i> Acceso
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {usuarios.map(usuario => (
                                                                <tr key={usuario.id} className={usuario.es_usuario_actual ? 'table-primary' : ''}>
                                                                    <td>
                                                                        <strong>{usuario.name} {usuario.lastname}</strong>
                                                                        {usuario.es_usuario_actual && <span className="badge badge-info ml-2">Tú</span>}
                                                                        <br/>
                                                                        <small className="text-muted">{usuario.email}</small>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <div className="custom-control custom-checkbox">
                                                                            <input 
                                                                                type="checkbox" 
                                                                                className="custom-control-input" 
                                                                                id={`acceso_${usuario.id}`}
                                                                                checked={permisosUsuarios[usuario.id]?.puede_ver || false}
                                                                                onChange={() => handlePermisoChange(usuario.id, 'puede_ver')}
                                                                            />
                                                                            <label className="custom-control-label" htmlFor={`acceso_${usuario.id}`}></label>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="alert alert-info">
                                                    <i className="fas fa-info-circle"></i> No hay otros usuarios en este cliente para asignar permisos.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Botones de Envío */}
                                    <div className="row mt-4">
                                        <div className="col-md-12">
                                            <div className="form-group mb-0 text-left d-flex align-items-center">
                                                <button 
                                                    type="button" 
                                                    className="btn btn-secondary mr-3 d-inline-flex align-items-center justify-content-center shadow-sm" 
                                                    onClick={() => history.push('/crear-agendas')}
                                                    style={{ padding: '8px 20px' }}
                                                >
                                                    <i className="fas fa-times mr-2"></i> Cancelar
                                                </button>
                                                <button 
                                                    type="submit" 
                                                    className="btn btn-primary d-inline-flex align-items-center justify-content-center shadow-sm" 
                                                    disabled={loading}
                                                    style={{ padding: '8px 20px' }}
                                                >
                                                    <i className="fas fa-save mr-2"></i> Crear Agenda
                                                    {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                            </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default NuevaAgenda;
